module.exports = __webpack_public_path__ + "static/media/damaru_daaa.810ee141.ogg";